// Taking back tasks / a simulation (backend/DTO/removal_dto.py) - what already happened decides: deleted (nothing
// left the office), cancelled with the reason (the client saw / signed, nothing sent to the producer) or blocked.
export enum RemovalReason {
  CLIENT_CHANGED_MIND = "CLIENT_CHANGED_MIND",
  CREATED_BY_MISTAKE = "CREATED_BY_MISTAKE",
  REPLACED = "REPLACED",
  OTHER = "OTHER",
}

export enum RemovalOutcome {
  DELETED = "DELETED",
  CANCELLED = "CANCELLED",
  BLOCKED = "BLOCKED",
}

export enum RemovalBlockReason {
  SENT_TO_PRODUCER = "SENT_TO_PRODUCER",
  REPORTED_BY_PRODUCER = "REPORTED_BY_PRODUCER",
  TASK_CLOSED = "TASK_CLOSED",
  ALREADY_CANCELLED = "ALREADY_CANCELLED",
}

export interface RemovalRequest {
  reason: RemovalReason;
  note?: string;
}

export interface TaskRemovalResult {
  task_id: number;
  outcome: RemovalOutcome;
  blocked_reason?: RemovalBlockReason;
}

export interface RemovalResult {
  tasks: TaskRemovalResult[];
  simulation_outcome?: RemovalOutcome;
}

export const REMOVAL_REASON_LABELS: Record<RemovalReason, string> = {
  [RemovalReason.CLIENT_CHANGED_MIND]: "הלקוח התחרט",
  [RemovalReason.CREATED_BY_MISTAKE]: "נוצר בטעות",
  [RemovalReason.REPLACED]: "הוחלף בסימולציה / משימה אחרת",
  [RemovalReason.OTHER]: "אחר",
};

// the backend's refusals (HTTP 409 detail)
export const REMOVAL_ERROR_MESSAGES: Record<string, string> = {
  simulation_sent_to_producer: "הבקשה של הסימולציה כבר נשלחה ליצרן - לא ניתן לבטל אותה.",
  simulation_has_tasks_at_producer: "חלק מהמשימות של הסימולציה כבר אצל היצרן - לא ניתן לבטל אותה.",
  simulation_already_discarded: "הסימולציה כבר בוטלה.",
};

/** One line for the snackbar: how many were deleted / cancelled / left as they were */
export function summarizeRemoval(result: RemovalResult): string {
  const count = (outcome: RemovalOutcome) => result.tasks.filter((t) => t.outcome === outcome).length;
  const parts: string[] = [];
  if (result.simulation_outcome === RemovalOutcome.DELETED) parts.push("הסימולציה נמחקה");
  if (result.simulation_outcome === RemovalOutcome.CANCELLED) parts.push("הסימולציה בוטלה ונשמרה עם הסיבה");
  const deleted = count(RemovalOutcome.DELETED);
  const cancelled = count(RemovalOutcome.CANCELLED);
  const blocked = result.tasks.filter(
    (t) => t.outcome === RemovalOutcome.BLOCKED && t.blocked_reason !== RemovalBlockReason.ALREADY_CANCELLED
  ).length;
  if (deleted) parts.push(`${deleted} נמחקו`);
  if (cancelled) parts.push(`${cancelled} בוטלו ונשמרו (הלקוח כבר ראה / חתם)`);
  if (blocked) parts.push(`${blocked} לא שונו (כבר אצל היצרן או סגורות)`);
  return parts.join(" · ") || "לא בוצע שינוי";
}
